import { render } from "./DealsDetails.vue?vue&type=template&id=7274335e&scoped=true"
import script from "./DealsDetails.vue?vue&type=script&lang=js"
export * from "./DealsDetails.vue?vue&type=script&lang=js"

import "./DealsDetails.vue?vue&type=style&index=0&id=7274335e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7274335e"]])

export default __exports__